import {Component, HostListener, OnDestroy, OnInit} from "@angular/core";
import {ActivatedRoute, NavigationEnd, Router} from "@angular/router";
import {filter} from "rxjs/operators";
import {AuthenticationService} from "src/core/services/authentication.service";
import {PreviousFilingIdService} from "src/core/services/shared/filingId.service";
import {interval} from "rxjs";
import {AlertQualityGateService} from "../api/services/alert-quality-gate.service";
import {AlertQualityGate} from "../api/models/alert-quality-gate";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
  standalone: false,
})
export class AppComponent implements OnInit, OnDestroy {
  title = "10B5-1";
  subtitle = "E-Commerce";
  isLoggedIn = false;
  sidebarVisible = true;
  userDropdownVisible = false;
  currentTitle: string = "";
  issuerName: string = '';
  isLoginPage: boolean = false;
  username: string = "";
  previousFilingId: string | null = null;
  previousFilingState: string | null = null;
  protected _newEntries = 0;
  private _subscriptionQualityGate: any;

  // isUserDropdownOpen: boolean = false;
  constructor(
    private router: Router,
    private authService: AuthenticationService,
     private route: ActivatedRoute,
    private _alertQualityGateService: AlertQualityGateService,
    private previousFilingIdService: PreviousFilingIdService
  ) {
    this.isLoggedIn = authService.isLoggedIn();
    if (!this.isLoggedIn) {
      this.router.navigate(["login"]);
    }
  }

  ngOnDestroy(): void {
    this._subscriptionQualityGate.unsubscribe();
  }

  ngOnInit(): void {
    this.getAlertsForQualityGate();
    this._subscriptionQualityGate = interval(120000).subscribe(() => {
      this.getAlertsForQualityGate();
    });

    this.clockToRun();
    // Set initial sidebar visibility based on screen width
    this.sidebarVisible = window.innerWidth >= 768;
    // Listen to username changes
    this.authService.username$.subscribe((name) => {
      if (name) {
        this.username = this.capitalizeEachWord(name);
      }
    });
    // Update currentTitle on route changes
this.router.events
  .pipe(filter(event => event instanceof NavigationEnd))
  .subscribe(() => {
    // Full URL without hash
    const url = this.router.url.split("#")[0];

    this.isLoginPage = url.includes('login');

    // Take only the first segment before `?`
    const firstSegment = url.split("?")[0].replace(/^\/+/, "");
    // Format the title
    this.currentTitle = this.formatTitle(firstSegment);

    // Append issuer name if on issuer-details page
    // if (firstSegment === 'issuer-details') {
    //   const issuerName = this.route.snapshot.queryParamMap.get('issuerName');
    //   if (issuerName) {
    //     this.currentTitle += `  (${issuerName})`;
    //   }
    // }

    if (window.innerWidth < 768) this.sidebarVisible = false;

    console.log("currentTitle", this.currentTitle);

    // this.router.events
    //   .pipe(filter((event) => event instanceof NavigationEnd))
    //   .subscribe((event: any) => {
    //     const urlBeforeHash = event.urlAfterRedirects.split("#")[0]; // get part before #
    //     const path = urlBeforeHash.split("/")[1] || "inbox";
    //     this.currentTitle = this.formatTitle(path);
    //        // If on issuer-details page, append issuerName from query params
    //   if (path.startsWith('/issuer-details')) {
    //     debugger
    //     this.route.queryParams.subscribe(params => {
    //       debugger
    //       if (params['issuerName']) {
    //         debugger
    //         this.currentTitle = `${this.currentTitle} - ${params['issuerName']}`;
    //       }
    //     });
    //   }
    //     console.log("path",path)
    //     this.isLoginPage = path === "login";

    //     // Auto-close sidebar on small screens after navigation
    //     if (window.innerWidth < 768) {
    //       this.sidebarVisible = false;
    //     }
       });

    this.previousFilingIdService.previousFiling$.subscribe((data) => {
      this.previousFilingId = data.filingId;
      this.previousFilingState = data.filingState;
    });
  }

  formatTitle(path: string): string {
    return path
      .replace(/-/g, " ") // Replace dashes with spaces
      .replace(/\b\w/g, (c) => c.toUpperCase())
      .split("?")[0]; // Capitalize each word
  }

  toggleSidebar() {
    this.sidebarVisible = !this.sidebarVisible;
  }

  capitalizeEachWord(name: string): string {
    return name
      .toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  }

  getInitials(name: string): string {
    return name
      ?.split(" ")
      .map((n) => n[0])
      .join("")
      .toUpperCase();
  }

  toggleUserDropdown() {
    this.userDropdownVisible = !this.userDropdownVisible;
  }

  logout() {
    this.authService.logout();
    this.isLoggedIn = false;
  }

  // Listen to window resize to toggle sidebar automatically
  @HostListener("window:resize", ["$event"])
  onResize(event: any) {
    this.sidebarVisible = event.target.innerWidth >= 768;
  }

  clockToRun() {
    const x = setInterval(function () {
      const expireAt = localStorage.getItem('expires_at');
      if (!expireAt) {
        return;
      }
      const countDownDate: any = new Date(Number(expireAt));
      const now = new Date().getTime();
      const distance: any = countDownDate - now;
      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);
      if (document.getElementById('demo')) {
        // @ts-ignore
        document.getElementById('demo').innerHTML = 'Token Expires in :  ' + days + 'd ' + hours + 'h '
          + minutes + 'm ' + seconds + 's ';
      }
      if (days === 0 && hours === 0 && minutes === 10 && seconds === 0) {
        alert('Session about to expire');
      }
      if (distance < 0) {
        clearInterval(x);
        if (document.getElementById('demo')) {
          // @ts-ignore
          document.getElementById('demo').innerHTML = 'EXPIRED';
        }
      }
    }, 1000);
  }

  private getAlertsForQualityGate() {
    let alerts = [] as AlertQualityGate[];
    this._alertQualityGateService.getAlertsForQualityGates().subscribe({
      next: value => {
        alerts = value;
      },
      complete: () => {
        this._newEntries = alerts.reduce((sum, item) => sum + (item.entriesAdded ?? 0), 0);
      }
    });
  }
}
